// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__27vIa","header":"ReportDetails_header__1Sxr5","title":"ReportDetails_title__140vf","left":"ReportDetails_left__wTj6F"};